import { TextField, Button, Modal, Box, Typography, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { getSessionUser } from "../../utils/users";
import { apiAutenticacao, headers } from "../../services/api";
import { useNavigate } from 'react-router-dom';

export const Profile = ({ showLoading, hideLoading, showError }: any) =>{
    let navigate = useNavigate();

  const [nome, setNome] = useState<string | undefined>("");
  const [telefone, setTelefone] = useState<string>("");
  const [email, setEmail] = useState<string | undefined>("");
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleChangeNome = ({ target }: any) => {
    setNome(target.value);
  };

  const handleChangeTelefone = ({ target }: any) => {
    setTelefone(target.value);
  };

  const handleChangeEmail = ({ target }: any) => {
    setEmail(target.value);
  };

  useEffect(() => {
    const user = getSessionUser();
    if (user) {
      setNome(user?.nomeUsuario);
      setEmail(user?.login);
    }
  }, []);

  const editUser = async () => {
    showLoading("Atualizando o perfil");
    try {
      const config = {
        headers: headers(),
      };

      const response = await apiAutenticacao.post(
        "usuario/atualizar/usuario",
        {
          nome: nome,
          email: email
        },
        config
      );

      hideLoading();
      setModalMessage(
        "A alteração será refletida no próximo login na plataforma!"
      );
      setOpenModal(true);
    } catch (error: any) {
      showError("Erro ao atualizar", "Não foi possível atualizar o perfil.");
      hideLoading();
    }

    return;
  };

  const handleClose = () => {
    setOpenModal(false);

    navigate(`/historico`);
  };

  const body = (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid var(--border-hairline)",
        boxShadow: 24,
        p: 4,
      }}
    >
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {modalMessage}
      </Typography>
      <Button onClick={handleClose}>Fechar</Button>
    </Box>
  );

  return (
    <>
      <Box sx={{textAlign: "center", fontSize: "20px", color: "var(--text-secondary)"}}>
          <h3>Meu Perfil</h3>
      </Box>
      <Stack spacing={3} sx={{ marginBlock: 3 }}>
          <TextField value={nome} label="Nome" onChange={handleChangeNome} fullWidth></TextField>
          <TextField sx={{display: "none"}} value={telefone} label="Telefone" onChange={handleChangeTelefone} ></TextField>
          <TextField value={email} label="Email" onChange={handleChangeEmail} fullWidth disabled></TextField>
      </Stack>
      <Box sx={{display: "flex", justifyContent: "end"}}>
          <Button 
              sx={{ width: "120px"}} 
              color="secondary" 
              variant="contained" 
              onClick={() => editUser()}
          > Salvar 
          </Button>
      </Box>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {body}
      </Modal>
    </>
  );
};
